// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lRUt","right":"styles_right__LiV7T"};